import type { Agreement } from 'agreement/permission-types';

import { checkAcl } from 'components/acl';

export const isBoxReorderAllowed = (agreement: Agreement) => (
  checkAcl(agreement.acl, 'agreement:box:reorder')
);
